import type { SupplierRequestType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import SupplierRequestsTableRow from './SupplierRequestsTableRow';

interface SupplierRequestsTableBodyProps {
    requests: SupplierRequestType[];
    canOps: boolean;
    onOpen: (requestId: number) => void;
    onClone: (row: SupplierRequestType) => void;
    onChanged: () => void;
    onSendEmail: (row: SupplierRequestType) => void;
}

const SupplierRequestsTableBody = ({
    requests,
    canOps,
    onOpen,
    onClone,
    onChanged,
    onSendEmail,
}: SupplierRequestsTableBodyProps) => {
    if (!requests.length) {
        return (
            <tbody>
                <tr>
                    <td colSpan={8}>
                        <EmptyResult />
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <tbody>
            {requests.map((row) => (
                <SupplierRequestsTableRow
                    key={row.ID}
                    row={row}
                    canOps={canOps}
                    onOpen={onOpen}
                    onClone={onClone}
                    onChanged={onChanged}
                    onSendEmail={onSendEmail}
                />
            ))}
        </tbody>
    );
};

export default SupplierRequestsTableBody;
